import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontSize: theme.cash ? "1.9rem" : "2rem",
    fontWeight: theme.typography.fontWeightBold,
  },
  subtitle: {
    lineHeight: "1.5",
  },
}));

export const LeftSidebar: React.FC<{ heading: string; subheading: string }> = ({
  children,
  heading,
  subheading,
}) => {
  const classes = useStyles();
  return (
    <Box>
      <Box mb={2}>
        <Typography variant="h5" className={classes.heading}>
          {heading}
        </Typography>
      </Box>
      <Box mb={4}>
        <Typography variant="body1" className={classes.subtitle}>
          {subheading}
        </Typography>
      </Box>
      {children}
    </Box>
  );
};
